// extracted by mini-css-extract-plugin
module.exports = {"academyContainer":"Academy_academyContainer__2l3vL","academy":"Academy_academy__33UOu"};